class UseNotifyProvider implements ng.IServiceProvider {
    UseNotify;

    provide(_UseNotify_) {
        this.UseNotify = _UseNotify_;
    }

    public $get = () => {
        return this.UseNotify;
    };
}

angular.module('hjApp').provider('UseNotify', [() => new UseNotifyProvider()]);
